export default __webpack_public_path__ + "static/plan-ahead-w-caption-ea91594b3160f30c99b6f936e12cce08.png";